import { Color, PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#FFF8E7',
  100: '#eeeeee',
  200: '#d5d5d5',
  300: '#c1c1c1',
  400: '#a0a0a0',
  500: '#7f7f7f',
  600: '#6b6b6b',
  700: '#4A4A4A',
  800: '#434343',
  900: '#2F2F2F',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary: PaletteColorOptions = {
  light: '#55D98D',
  main: '#2ECC71',
  dark: '#247D51',
  contrastText: '#FFFFFF',
};

const secondary: PaletteColorOptions = {
  light: '#85C6E5',
  main: '#5DADE2',
  dark: '#2E86C1',
  contrastText: '#000000',
};

const info: PaletteColorOptions = {
  light: '#C2F8CB',
  main: '#AAF0D1',
  dark: '#6DC19D',
  contrastText: '#000000',
};

const naturalPalette: PaletteOptions = {
  mode: 'light',
  action: {
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#333333',
    secondary: '#475569',
    disabled: '#a0a0a0',
  },
  background: { paper: '#FFF8E7', default: '#FFFFFF' },
};

export default naturalPalette;
